'use client';
import React, {useState} from 'react';
import {connect} from 'react-redux';

import {getListingSubscriptions} from 'features/vip/actions';
import {get, getListingType} from 'utils/helpers';
import {hideModal} from 'features/modal/slice';
import {editListing} from 'features/listings/actions';
import {notifySuccessWithTimeout} from 'features/notification/slice';
import ChangeListingTypeForm from 'features/listings/components/ChangeListingTypeForm/ChangeListingTypeForm';
import {LISTING_TYPES_PAID} from 'core/constants';

let ChangeListingTypeFormContainer = (props) => {
    const [state, setState] = useState({
        error: null,
    });

    const handleClose = () => props.hideModal();

    const handleSubmit = () => {
        const {listing, toType} = props;
        let req = {
            listing_id: listing.listing_id,
            type: toType,
        };

        props
            .editListing(req)
            .then((data) => {
                if (getListingType(listing) === 'vip' && toType && toType !== 'vip') {
                    props.getListingSubscriptions(listing.listing_id);
                }
                props.notifySuccessWithTimeout(data.message);
                handleClose();
            })
            .catch((e) => {
                setState({
                    error: e && e.message ? e.message : 'Cannot edit listing type',
                });
            });
    };

    return (
        <ChangeListingTypeForm
            {...props}
            {...state}
            handleSubmit={handleSubmit}
            handleClose={handleClose}
        />
    );
};

ChangeListingTypeFormContainer = connect(
    (state, ownProps) => {
        const fromType =
            get(ownProps.listing, 'type.name') ||
            get(state, 'modal.props.listing.listing_type');
        const toType = ownProps.type;

        return {
            fromType,
            toType,
            isSaving: state.listings.isSaving,
            includeVipWarning: fromType === 'vip' && toType !== 'vip',
            includeDowngradeWarning:
                LISTING_TYPES_PAID.includes(fromType) &&
                (toType === 'claimed' || toType === 'free'),
        };
    },
    {
        editListing,
        hideModal,
        getListingSubscriptions,
        notifySuccessWithTimeout,
    },
)(ChangeListingTypeFormContainer);

export default ChangeListingTypeFormContainer;
